import { useState } from 'react';

import { Menu } from 'components/Toolkit/Menu/Menu';
import { SimpleDropdown } from 'components/Toolkit/SimpleDropdown/SimpleDropdown';

export interface ISortOption {
  displayName: string;
  value: string;
}

export const SORT_OPTIONS: ISortOption[] = [
  { value: '', displayName: 'Best match' },
  { value: 'publishdatedesc', displayName: 'Newest' },
  { value: 'publishdateasc', displayName: 'Oldest' },
  { value: 'pricedesc', displayName: 'Highest price' },
  { value: 'priceasc', displayName: 'Lowest price' },
];

export interface ISortProps {
  onChange: (value: string) => void;
  selected: string;
}

function Sort({ selected, onChange }: ISortProps) {
  const [label, setLabel] = useState(
    selected
      ? SORT_OPTIONS.find((option) => option.value === selected)?.displayName
      : SORT_OPTIONS[0].displayName,
  );

  const handleClickOption = (option: ISortOption) => {
    onChange(option.value);
    setLabel(option.displayName);
  };

  return (
    <SimpleDropdown text={`Sort by: ${label}` || ''} variant="DEFAULT">
      <Menu
        items={SORT_OPTIONS.map((option) => ({
          onClick: () => handleClickOption(option),
          displayName: option.displayName,
        }))}
      />
    </SimpleDropdown>
  );
}

export { Sort };
